
<template>
  <div class="collect" :class="{ isIosx: isIosx }">
    <van-sticky :z-index="9999">
      <div class="collectNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">收藏</span>
        <span class="navRight" @click="setStudy()">管理</span>
      </div>
    </van-sticky>
    <div class="collectContent">
      <van-tabs
        line-width="16px"
        line-height="4px"
        title-inactive-color="#6E727A"
        title-active-color="#404247"
        v-model="active"
        @change="tabChange"
        ref="tabs"
      >
        <van-tab
          v-for="(item, index) in navList"
          :key="index"
          :title="item.title"
        >
          <!-- <div class="contentTop">
            <div>
              <van-dropdown-menu active-color="#4E7DF7">
                <van-dropdown-item
                  :title="dropdownTitle"
                  get-container="body"
                  ref="chargeType"
                >
                  <ul class="dropdownMenu">
                    <li
                      class="dropdownItem"
                      :class="{ dropdownItemCheck: item.check }"
                      v-for="(item, index) in dropdownOption"
                      :key="index"
                      @click="choice(item.value, item.text)"
                    >
                      {{ item.text }}
                    </li>
                  </ul>
                </van-dropdown-item>
              </van-dropdown-menu>
            </div>
          </div> -->
          <div v-if="loaded">
            <div class="collectMid" v-if="dataList.length > 0">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <CourseColum
                    :dataList="dataList"
                    @check="check"
                    @unCheck="unCheck"
                    :isSet="isSet"
                  ></CourseColum>
                </van-list>
              </van-pull-refresh>
            </div>
            <div v-else class="noData">
              <img src="./../../assets/school/collectionTip.png" />
              <p>无收藏课程</p>
            </div>
          </div>
          <div v-else class="load">
            <img src="./../../assets/school/loading.gif" />
            <p>加载中</p>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 选择课程底部操作框 -->
    <div class="setBtm" v-if="isSet">
      <div @click="allCheck()">
        <img src="./../../assets/school/check.png" v-if="isCheck" />
        <img src="./../../assets/school/unselected1.png" v-else />
        全选
      </div>
      <div>
        <span @click="del()">移除({{ this.delList.length }})</span>
      </div>
    </div>
  </div>
</template>

<script>
import CourseColum from "./components/courseColumn.vue";
export default {
  data() {
    return {
      isIosx: false,
      loaded: false,
      navList: [
        { title: "全部", value: 0 },
        { title: "图文", value: 3 },
        { title: "视频", value: 2 },
        { title: "音频", value: 4 },
        { title: "专栏", value: 1 },
      ],
      dropdownOption: [
        { text: "全部", value: 0, check: true },
        { text: "免费", value: 1, check: false },
        { text: "不免费", value: -1, check: false },
      ],
      dropdownTitle: "收费类型",
      active: 0,
      dataList: [],
      type: 0,
      cost_type: 0,
      isSet: false, //是否开始选择课程
      delList: [],
      isCheck: false,
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
    };
  },
  components: { CourseColum },
  mounted() {
    this.isIosx = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getData();
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    // 管理
    setStudy() {
      this.isSet = !this.isSet;
    },
    // tab切换
    tabChange(name, title) {
      this.type = this.navList[name].value;
      this.isSet = false;
      this.isCheck = false;
      this.delList = [];
      this.onRefresh();
      this.loaded = false;
    },
    // 下拉筛选选择
    choice(value, title) {
      this.dropdownOption.forEach((item) => {
        item.check = false;
        if (item.value == value) {
          item.check = true;
        }
      });
      this.cost_type = value;
      this.dropdownTitle = title == "全部" ? "收费类型" : title;
      this.$refs.chargeType.forEach((item) => {
        item.toggle(false);
      });
      this.onRefresh();
    },
    // 获取数据
    getData() {
      this.$api
        .post("school/member/collection/list", {
          type: this.type, //类型：Number  必有字段  备注：0.全部,1.专栏 ,2.视频,3.图文,4.音频
          page: this.page, //类型：Number  必有字段  备注：1
          pageSize: this.pageSize, //类型：Number  必有字段  备注：10
          cost_type: this.cost_type, //类型：Number  必有字段  备注：0.全部，1:免费，2:付费，3:积分
        })
        .then((res) => {
          this.dataList = this.dataList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    allCheck() {
      this.isCheck = !this.isCheck;
      this.delList = [];
      if (this.isCheck) {
        // 全选
        this.dataList.forEach((item) => {
          item.check = true;
          this.delList.push(item.id);
        });
      } else {
        // 不全选
        this.dataList.forEach((item) => {
          item.check = false;
        });
      }
      this.dataList = [...this.dataList];
    },
    check(item) {
      item.check = true;
      this.delList.push(item.id);
      this.dataList = [...this.dataList];
    },
    // 取消选择
    unCheck(item) {
      item.check = false;
      if (this.delList.indexOf(item.id) > -1) {
        this.delList.splice(this.delList.indexOf(item.id), 1);
      }
      this.dataList = [...this.dataList];
    },
    del() {
      // console.log(this.delList);
      this.$api
        .post("school/member/cancel/collection", {
          courses_ids: this.delList,
        })
        .then((res) => {
          this.$toast("移除成功！");
          this.isSet = false;
          this.delList = [];
          this.onRefresh();
        });
    },
  },
};
</script>

<style>
.load {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.load img {
  width: 80px;
  height: 80px;
  margin: 200px 0 0;
}
.load p {
  font-size: 12px;
  color: #9ca1ad;
}
.collectNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.collectNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.collectNav .navTitle {
  font-size: 17px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.collectNav .navRight {
  position: absolute;
  right: 16px;
}
/* content */
.collect .van-tab--active {
  font-weight: 700;
}
.collect .van-tab {
  flex: 1;
  font-size: 15px;
}
.van-tabs__line {
  background: linear-gradient(90deg, #4e7df7 0%, #86b4fc 100%);
}
.collectContent .contentTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 16px 0;
}
.collectContent .contentTop > div {
  width: 100px;
}
.contentTop .van-dropdown-menu__bar {
  height: 26px;
  box-shadow: none;
}
.contentTop .van-dropdown-menu__item {
  background-color: rgba(78, 125, 247, 0.1);
  margin-right: 16px;
  border-radius: 20px;
}
.contentTop .van-dropdown-menu__item:last-child {
  margin: 0;
}
.contentTop .van-dropdown-menu__title {
  font-size: 13px;
  color: #9ca1ad;
}
.contentTop > span img {
  width: 16px;
  height: 16px;
}
/* 自定义下拉菜单 */
.dropdownMenu {
  color: #404247;
  font-size: 13px;
  padding: 24px 32px 0;
}
.dropdownItem {
  margin-bottom: 24px;
}
.dropdownItemCheck {
  color: #4e7df7;
}
/* 列表 */
.collectMid {
  margin: 24px 16px;
}

/* 底部操作框 */
.collect .setBtm {
  width: 100%;
  height: 46px;
  background-color: #ffffff;
  position: fixed;
  left: 0;
  bottom: 0px;
  z-index: 999;
  box-shadow: 0px 1px 0px 0px #ffffff, 0px 1px 0px 0px #f7f8fc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}
.setBtm > div {
  margin: 0 16px;
  color: #404247;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.setBtm > div img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.setBtm > div span {
  width: 80px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  background-color: rgba(78, 125, 247, 0.1);
  color: #4e7df7;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  border-radius: 16px;
}

.isIosx .collectNav {
  padding-top: 44px;
}
.isIosx .setBtm {
  padding-bottom: 34px;
}

.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noData img {
  width: 235px;
  height: 235px;
}
.noData p {
  margin-top: 24px;
  font-size: 14px;
  color: #9ca1ad;
}

.collect .van-list__finished-text {
  margin-top: 48px;
}
</style>